/* eslint-disable */
import { useReactToPrint } from 'react-to-print';
import React, { useEffect, useRef, useState } from 'react';
import MoneyReport from './reports/MoneyReport';
import LoaderGraphic from './utils/LoaderGraphic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import Modal from 'react-modal';

const ExportPDFandPrint = (props) => {
    const reportRefs = useRef();
    const [PDFPrintModalOpen, setPDFPrintModalOpen] = useState(false);
    const [videoModalOpen, setVideoModalOpen] = useState(false);
    const [displayPages, setDisplayOptions] = useState(props.reportsOnTabs)
    let pagesToPDFandPrint = displayPages.filter(p => p.key !== 'report_builder')
    const navbar = window.navbar.navbar;

    useEffect(() => {
        setDisplayOptions(() => {
            if (props.page === 'money' || props.page === 'analysis') {
                return [{ id: 0, key: 'cover_page', report: 'cover_page', name: 'Cover Page', checked: true, tab_order: 0 }, ...props.reportsOnTabs]
            }
        })
    }, [props.reportsOnTabs, props.page])

    const pdfIcon = <FontAwesomeIcon icon={faFilePdf} />

    const openVideoModal = () => {
        setVideoModalOpen(true);
    }

    const closeVideoModal = () => {
        setVideoModalOpen(false);
    }

    const closePDFPrintModal = () => {
        setPDFPrintModalOpen(false);
    }

    const VideoModal = () => {
        let videoLink = null
        let modalPic = require('../../assets/images/PremiumExcelPDF.png')

        const hrefBuilder = (subdomain, path) => {
            const domainSplit = document.location.host.split('.');
            domainSplit[0] = subdomain;
            return location.protocol + '//' + domainSplit.join('.') + path;
        };

        const manageSubscriptionsURL = hrefBuilder(navbar.subdomain, '/subscriptions')
        const unlockReportsURL = hrefBuilder(navbar.subdomain, navbar.unlock_reports_url)
        const linkText = navbar.report_credits ? "Unlock Reports" : "Buy More Report Credits"
        const purchaseText = "Buy more report credits."

        return (
            <Modal
                className={{
                    base: 'video-modal-content hide-on-print',
                    afterOpen: 'video-modal-content_after-open hide-on-print',
                    beforeClose: 'video-modal-content_before-close hide-on-print',
                }}
                overlayClassName={{
                    base: 'overlay-base hide-on-print',
                    afterOpen: 'overlay-base_after-open hide-on-print',
                    beforeClose: 'overlay-base_before-close hide-on-print',
                }}
                isOpen={videoModalOpen}
                onRequestClose={closeVideoModal}
                shouldCloseOnOverlayClick={true}
                closeTimeoutMS={0}
                contentLabel='Video About Report Features'
                ariaHideApp={false}
            >
                <div>
                    <h1>Upgrade to Access These Reports</h1>
                    <img className='premium-pic-popup' src={modalPic}></img>
                    {(props.planAccess.print_and_pdf && !navbar.reports_unlocked || props.planAccess.export_to_excel && !navbar.reports_unlocked)
                        ? (<div className='unlock-report-container'>
                            <p>{`You have ${navbar.report_credits} Report Credits left.`} <a className='btn btn-primary unlock-report-btn' href={unlockReportsURL}>{linkText}</a></p>
                        </div>)
                        : null}
                    <a className='btn btn-primary manage-subscription-btn' href={manageSubscriptionsURL}>Manage Your Subscription</a>
                    <p>Click anywhere outside to close this pop-up.</p>
                </div>
            </Modal>
        )
    }

    const handlePDFandPrintChecked = (key, index) => {
        setDisplayOptions((prevState) => {
            let newOptions = _.cloneDeep(prevState)
            newOptions[index]['checked'] = !newOptions[index]['checked']
            return newOptions
        })
    }

    let pdfButtonId = 'moneyPdfId';

    const handleOpeningReportBuilder = () => {
        props.fetchAllCalcsByTabs()
        setPDFPrintModalOpen(true)
    }

    const getPDFButton = () => {
        if ((!props.planAccess.print_and_pdf && navbar.user_type !== 'Admin') || (!navbar.reports_unlocked && props.planAccess.print_and_pdf && navbar.user_type !== 'Admin')) {
            return (
                <span className='hide-on-print'>
                    <button id={pdfButtonId} className='print-pdf-btn' aria-hidden='true' onClick={() => openVideoModal()}>{pdfIcon}</button>
                </span>
            )
        }

        if (navbar.reports_unlocked && props.planAccess.print_and_pdf || navbar.user_type === 'Admin') {
            return (
                <span className='hide-on-print'>
                    <button id={pdfButtonId} className='print-pdf-btn' onClick={() => handleOpeningReportBuilder()} aria-hidden='true' >{pdfIcon}</button>
                </span>
            )
        }
    }

    // The PDF print uses a completely separate PDFable MoneyReport to look at
    const renderReport = () => {
        return (
            <MoneyReport
                ref={reportRefs}
                key={'money-report-container-pdf'}
                {...props}
                displayPages={pagesToPDFandPrint}
                page={'money'}
                pdf={true}
            />
        )
    };

    const handlePrint = useReactToPrint({
        contentRef: reportRefs,
        documentTitle: `${props.name}Report.pdf`,
    });

    const printPDFExport = () => {
        let loadingStyle = props.loading ? { pointerEvents: 'none' } : {}
        if (navbar.reports_unlocked && props.planAccess.print_and_pdf || navbar.user_type === 'Admin') {
            return (
                <Modal
                    className={{
                        base: 'pdf-print-modal-content hide-on-print',
                        afterOpen: 'pdf-print-modal-content_after-open hide-on-print',
                        beforeClose: 'pdf-print-modal-content_before-close hide-on-print',
                    }}
                    overlayClassName={{
                        base: 'overlay-base hide-on-print',
                        afterOpen: 'overlay-base_after-open hide-on-print',
                        beforeClose: 'overlay-base_before-close hide-on-print',
                    }}
                    isOpen={PDFPrintModalOpen}
                    onRequestClose={closePDFPrintModal}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={0}
                    contentLabel='PDF and Print Preview'
                    ariaHideApp={false}
                >
                    <div className='report-builder-container' style={loadingStyle}>
                        <h2>Report Builder</h2>
                        <p>Include: </p>
                        {
                            props.loading
                            ? <LoaderGraphic logoLoader={true} />
                            : (<div className='report-builder-all-checkboxes'>
                                    <div>
                                        <div key={`cover_page-checkbox`} className='page-checkbox-input'>
                                            <input id={`cover_page-checked`} type='checkbox' name={'cover_page'} value={'cover_page'} checked={displayPages[0]['checked']} onChange={(e) => handlePDFandPrintChecked(e.target.value, 0)} />
                                            <label htmlFor={`cover_page-checked`}>Cover Page</label>
                                        </div>
                                    </div>
                                    <div className='report-pages-checkboxes'>
                                        {displayPages.map((tab, index) => {
                                            if (index > 0) {
                                                return (
                                                    <div key={`${tab.key}-checkbox`} className='page-checkbox-input'>
                                                        <input id={`${tab.key}-checked`} type='checkbox' name={tab.key} value={tab.key} checked={displayPages[index]['checked']} onChange={(e) => handlePDFandPrintChecked(e.target.value, index)} />
                                                        <label htmlFor={`${tab.key}-checked`}>{tab.name}</label>
                                                    </div>
                                                )
                                            }
                                        })}
                                    </div>
                            </div>)
                        }
                        <button 
                            id={pdfButtonId}
                            className='run-report-btn pdf-print-action-btn'
                            aria-hidden='true'
                            onClick={handlePrint}
                        >
                            Print my Client Report
                        </button>
                    </div>
                    {renderReport()}
                </Modal>
            )
        }
    }

    return (
        <>
            <VideoModal />
            {getPDFButton()}
            {printPDFExport()}
        </>
    )
};
export default ExportPDFandPrint;